@if (
  {
    violations: violations$ | async,
    sectors: sectors$ | async
  };
  as STATE
) {
  <article class="campaign-creation-form">
    <custom-modal-card>
      <ng-container header>
        <default-modal-header
          [title]="advertiser()?.id ? 'Modifier un groupe' : 'Créer un groupe'"
          [description]="
            advertiser()?.id
              ? 'Renseigner le champ ci-dessous pour la modification d\'un groupe'
              : 'Renseigner le champ ci-dessous pour la création d\'un groupe'
          "
        ></default-modal-header>
      </ng-container>
      <ng-container body>
        <form [formGroup]="form" (ngSubmit)="onSubmit()" class="resource-form">
          <article>
            <mat-label>Nom du groupe *</mat-label>
            <mat-form-field color="primary">
              <input
                formControlName="name"
                matInput
                placeholder="Nom du groupe"
                trim="blur"
              />
              <mat-error
                *ngIf="
                  $any(form.get('name'))?.getError('httpError') as httpError
                "
              >
                <strong>{{ httpError }}</strong>
              </mat-error>
            </mat-form-field>
          </article>

          <button
            type="submit"
            [attr.loading]="isSubmitting()"
            [disabled]="!form.valid || isSubmitting()"
            button
          >
            Enregistrer
          </button>
        </form>
      </ng-container>
    </custom-modal-card>
  </article>
}
